import merge from 'lodash/merge';

import i18n from '@rygen/rygen-ui/i18n';
import enRygenUi from '@rygen/rygen-ui/i18n/locales/en.json';

import enProject from './locales/en.json';

const englishTranslations = merge(enProject, enRygenUi);
i18n.global.setLocaleMessage('en-US', englishTranslations);
i18n.global.setLocaleMessage('en', englishTranslations);

export { i18n };
export default i18n;
